<template>
	<div v-if="value.length" class="file-list mb-2 text-small">
		<div v-for="(file, index) in value" :key="index" class="file-list__wrapper mb-1">
			<div class="file-list__file-name">{{ file.name }}</div>
			<button type="button" class="file-list__remove-button" @click="remove(index)">Fjern</button>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			type: Array,
			default: () => [],
		},
	},

	methods: {
		remove(index) {
			this.value.splice(index, 1)
		},
	},
}
</script>
